module.exports = __webpack_public_path__ + "img/default-user.f909f63c.png";